// Notifications from the API carry per-language fields (title_en/message_en,
// title_es/message_es). Older records were created before those fields
// existed, so fall back to the plain title/message in that case.
export const getLocalizedNotification = (notification, language) => {
  if (!notification) return { title: "", message: "" };
  const lang = language === "es" ? "es" : "en";
  return {
    title: notification[`title_${lang}`] || notification.title || "",
    message: notification[`message_${lang}`] || notification.message || "",
  };
};
